// REST client for /api/preferred_sign_in_method: read which 2FA method
// (passkey or authenticator app) is configured/preferred, and switch the
// default when the user has both set up.
import apiFetch from "../apiFetch";

const parseErrorMessage = async (response, fallback) => {
  const body = await response.json().catch(() => null);
  return body?.message || fallback;
};

export const getPreferredSignInMethod = async () => {
  const response = await apiFetch("/api/preferred_sign_in_method");
  if (!response.ok) {
    throw new Error(
      await parseErrorMessage(
        response,
        "Failed to load preferred sign-in method."
      )
    );
  }
  return response.json();
};

export const updatePreferredSignInMethod = async (preferred2faMethod) => {
  const response = await apiFetch("/api/preferred_sign_in_method", {
    method: "PATCH",
    body: JSON.stringify({ preferred_2fa_method: preferred2faMethod }),
  });
  if (!response.ok) {
    throw new Error(
      await parseErrorMessage(
        response,
        "Failed to update preferred sign-in method."
      )
    );
  }
  return response.json();
};
